import { lazy } from 'react';

export const EmptyTabs = {
    EmptyTab: lazy(() => import('./empty-tab')),
};
